import PropTypes from 'prop-types';
import React from 'react';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { Centro, Linha, Interno } from '../../styles/base';

const CardTelefone = ({
  departamento, email, endereco, horarioFuncionamentoAte01, horarioFuncionamentoAte02, horarioFuncionamentoDe01, horarioFuncionamentoDe02, secretaria, telefone,
}) => (
  <div>
    {(departamento) && (
      <p>
        <span style={{ fontWeight: 'bolder' }}>Departamento:</span>
        {' '}
        {departamento}
      </p>
    )}
    {(email) && (
    <p>
      <span style={{ fontWeight: 'bolder' }}>E-mail:</span>
        {' '}
      {email}
    </p>
    )}
    {(endereco) && (
    <p>
      <span style={{ fontWeight: 'bolder' }}>Endereço:</span>
        {' '}
      {endereco}
    </p>
    )}
    {(horarioFuncionamentoDe01) && (
    <p>
      <span style={{ fontWeight: 'bolder' }}>Horário de Funcionamento - De:</span>
        {' '}
      {horarioFuncionamentoDe01}
    </p>
    )}
    {(horarioFuncionamentoAte01) && (
    <p>
      <span style={{ fontWeight: 'bolder' }}>Horário de Funcionamento - Até:</span>
        {' '}
      {horarioFuncionamentoAte01}
    </p>
    )}
    {(horarioFuncionamentoDe02) && (
    <p>
      <span style={{ fontWeight: 'bolder' }}>Horário de Funcionamento (2) - De:</span>
        {' '}
      {horarioFuncionamentoDe02}
    </p>
    )}
    {(horarioFuncionamentoAte02) && (
    <p>
      <span style={{ fontWeight: 'bolder' }}>Horário de Funcionamento (2) - Até:</span>
        {' '}
      {horarioFuncionamentoAte02}
    </p>
    )}
    {(secretaria) && (
    <p>
      <span style={{ fontWeight: 'bolder' }}>Secretaria:</span>
        {' '}
      {secretaria}
    </p>
    )}
    {(telefone) && (
    <p>
      <span style={{ fontWeight: 'bolder' }}>Telefone:</span>
        {' '}
      {telefone}
    </p>
    )}
  </div>
);

CardTelefone.propTypes = {
  departamento: PropTypes.string,
  email: PropTypes.string,
  endereco: PropTypes.string,
  horarioFuncionamentoAte01: PropTypes.string,
  horarioFuncionamentoAte02: PropTypes.string,
  horarioFuncionamentoDe01: PropTypes.string,
  horarioFuncionamentoDe02: PropTypes.string,
  secretaria: PropTypes.string,
  telefone: PropTypes.string,
};

CardTelefone.defaultProps = {
  departamento: '',
  email: '',
  endereco: '',
  horarioFuncionamentoAte01: '',
  horarioFuncionamentoAte02: '',
  horarioFuncionamentoDe01: '',
  horarioFuncionamentoDe02: '',
  secretaria: '',
  telefone: '',
};

export default CardTelefone;
